var _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSilverCrown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "crown 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1956_8975",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0 0H40V40H0V0Z",
    fill: "white"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1956_8975)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.9845 28.1394C20.4403 28.9692 19.5603 28.9692 19.0171 28.1394L14.0929 22.7516C13.5498 21.9207 13.5498 20.5757 14.0929 19.7469L19.0171 10.1082C19.5603 9.27948 20.4403 9.27948 20.9845 10.1082L25.9087 19.7469C26.4519 20.5757 26.4519 21.9207 25.9087 22.7516L20.9845 28.1394Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M30.9845 30.2644C30.4403 31.0942 29.5603 31.0942 29.0171 30.2644L24.0929 24.8766C23.5498 24.0457 23.5498 22.7017 24.0929 21.8719L31.1224 12.2332C31.6655 11.4045 32.5455 11.4045 33.0898 12.2332L35.9087 21.8719C36.4519 22.7017 36.4519 24.0457 35.9087 24.8766L30.9845 30.2644Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.9846 30.2644C10.4404 31.0942 9.55931 31.0942 9.0151 30.2644L4.09194 24.8766C3.54878 24.0457 3.54878 22.7017 4.09194 21.8719L6.90983 12.2332C7.45404 11.4045 8.3351 11.4045 8.87931 12.2332L15.9088 21.8719C16.4519 22.7017 16.4519 24.0457 15.9088 24.8766L10.9846 30.2644Z",
    fill: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M35.7898 12.7496C34.3203 14.2345 32.9154 15.7833 31.5793 17.3915L26.774 7.98443C26.2298 7.15464 25.3498 7.15464 24.8056 7.98443L20.0003 17.3905L15.1951 7.98443C14.6509 7.15464 13.7698 7.15464 13.2256 7.98443L8.42139 17.3905C7.08536 15.7825 5.68052 14.2341 4.21087 12.7496C3.15824 11.6871 1.59508 11.7509 2.1056 13.8121C3.15824 18.062 3.15824 21.2494 3.15824 26.5617V28.6866C3.15824 29.8138 3.60184 30.8948 4.39147 31.6918C5.1811 32.4888 6.25206 32.9365 7.36876 32.9365H32.6319C33.7486 32.9365 34.8196 32.4888 35.6092 31.6918C36.3988 30.8948 36.8424 29.8138 36.8424 28.6866V26.5617C36.8424 21.2494 36.8424 18.062 37.8951 13.8121C38.4045 11.7509 36.8424 11.6871 35.7898 12.7496Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M23.1586 24.4366C23.1586 25.282 22.8259 26.0927 22.2336 26.6905C21.6414 27.2882 20.8382 27.624 20.0007 27.624C19.1631 27.624 18.3599 27.2882 17.7677 26.6905C17.1755 26.0927 16.8428 25.282 16.8428 24.4366C16.8428 23.5913 17.1755 22.7805 17.7677 22.1828C18.3599 21.585 19.1631 21.2492 20.0007 21.2492C20.8382 21.2492 21.6414 21.585 22.2336 22.1828C22.8259 22.7805 23.1586 23.5913 23.1586 24.4366Z",
    fill: "#0160FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M30.527 24.4366C30.5269 24.7157 30.4724 24.9921 30.3665 25.2499C30.2606 25.5078 30.1055 25.742 29.9099 25.9394C29.7143 26.1367 29.4821 26.2932 29.2266 26.3999C28.9711 26.5067 28.6972 26.5616 28.4207 26.5615C28.1442 26.5615 27.8703 26.5064 27.6149 26.3995C27.3594 26.2926 27.1273 26.136 26.9318 25.9386C26.7363 25.7412 26.5813 25.5068 26.4755 25.2489C26.3698 24.991 26.3154 24.7146 26.3154 24.4355C26.3156 23.8718 26.5376 23.3312 26.9326 22.9327C27.3276 22.5342 27.8633 22.3104 28.4217 22.3106C28.9802 22.3107 29.5158 22.5348 29.9106 22.9335C30.3054 23.3322 30.5271 23.8729 30.527 24.4366Z",
    fill: "#0160FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M37.8952 24.4366C37.8951 24.7157 37.8406 24.9921 37.7347 25.2499C37.6288 25.5078 37.4736 25.742 37.278 25.9394C37.0824 26.1367 36.8503 26.2932 36.5947 26.3999C36.3392 26.5067 36.0654 26.5616 35.7889 26.5615C35.5123 26.5615 35.2385 26.5064 34.983 26.3995C34.7276 26.2926 34.4955 26.136 34.3 25.9386C34.1045 25.7412 33.9494 25.5068 33.8437 25.2489C33.7379 24.991 33.6835 24.7146 33.6836 24.4355C33.6837 23.8718 33.9057 23.3312 34.3007 22.9327C34.6957 22.5342 35.2314 22.3104 35.7899 22.3106C36.3484 22.3107 36.884 22.5348 37.2788 22.9335C37.6736 23.3322 37.8953 23.8729 37.8952 24.4366Z",
    fill: "#0160FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M13.6842 24.4366C13.6842 25.0002 13.4624 25.5406 13.0675 25.9391C12.6727 26.3376 12.1372 26.5615 11.5789 26.5615C11.0205 26.5615 10.4851 26.3376 10.0903 25.9391C9.69544 25.5406 9.47363 25.0002 9.47363 24.4366C9.47363 23.873 9.69544 23.3325 10.0903 22.934C10.4851 22.5355 11.0205 22.3116 11.5789 22.3116C12.1372 22.3116 12.6727 22.5355 13.0675 22.934C13.4624 23.3325 13.6842 23.873 13.6842 24.4366Z",
    fill: "#0160FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M6.316 24.4366C6.316 25.0002 6.09419 25.5406 5.69938 25.9391C5.30456 26.3376 4.76908 26.5615 4.21073 26.5615C3.65238 26.5615 3.1169 26.3376 2.72209 25.9391C2.32727 25.5406 2.10547 25.0002 2.10547 24.4366C2.10547 23.873 2.32727 23.3325 2.72209 22.934C3.1169 22.5355 3.65238 22.3116 4.21073 22.3116C4.76908 22.3116 5.30456 22.5355 5.69938 22.934C6.09419 23.3325 6.316 23.873 6.316 24.4366Z",
    fill: "#0160FE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M36.8424 28.6866C36.8424 29.8138 36.3988 30.8948 35.6092 31.6918C34.8196 32.4888 33.7486 32.9365 32.6319 32.9365H7.36873C6.25203 32.9365 5.18107 32.4888 4.39144 31.6918C3.60181 30.8948 3.1582 29.8138 3.1582 28.6866H36.8424Z",
    fill: "#DADADA"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilverCrown);
export default __webpack_public_path__ + "static/media/SilverCrown.70010d2c110f53c329103dbce255c76f.svg";
export { ForwardRef as ReactComponent };